var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartBar = function SvgChartBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 2c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h2V6c0-1.1.9-2 2-2h3V2ZM6 8v6h3V6H6v2Zm-2 2H2v4h2v-4Zm10 4h-3V2h3v12Z",
    clipRule: "evenodd"
  })));
};
export default SvgChartBar;